import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BoardComponent} from './board/board.component';
import {CellComponent} from './cell/cell.component';
import {ControlsComponent} from './controls/controls.component';
import {GameComponent} from './game/game.component';
import {ScoreComponent} from './score/score.component';
import {GameService} from './game.service';
import {SharedModule} from '../../../../shared/shared.module';
import {MobxAngularModule} from 'mobx-angular';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    MobxAngularModule
  ],
  declarations: [BoardComponent, CellComponent, ControlsComponent, GameComponent, ScoreComponent],
  providers: [GameService],
  exports: [GameComponent]
})
export class TicTacToeModule {
}



// WEBPACK FOOTER //
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/pages/home/mobx-tic-tac/tic-tac-toe/tic-tac-toe.module.ts